import React from 'react';
import Page from 'components/pages/Page';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    indent: {
      marginLeft: '2em',
    },
//     root: {
//       flexGrow: 1,
//     },
//     column: {
//       textAlign: 'left',
//       color: theme.palette.text.secondary,
//     }
  }),
);


export default function AboutPage(props: any) {
  const classes = useStyles();

  return (
    <Page>
      <Grid container>
        <Grid item xs={12}>
          <h1><u>About ServicePlace</u></h1>
          <p>
          ServicePlace connects facilities and organizations with high quality, verified resources in times of need. We provide vetted opportunities for Americans to serve, contributing to our country’s resilience.
          </p>
          <br/>
          <h1><u>FAQs</u></h1>
          <p>For Professionals:</p>
          <ul>
            <li>Are these paid or volunteer opportunities?
              <ul className={classes.indent}>
                <li>
                  There are both paid and volunteer opportunities, depending on the organization needing help.
                </li>
              </ul>
            </li>
            <li>How are hiring decisions made?
              <ul className={classes.indent}>
                <li>
                  When you join ServicePlace, you create a searchable profile that is screened against the criteria of assignments. HR professionals at organizations in need can then find you. We will ONLY share contact details with verified medical facilities who need support, and they will make the hiring decisions.
                </li>
              </ul>
            </li>
            <li>Where will I work?
              <ul className={classes.indent}>
                <li>
                  Depending on the assignment and the travel information you provided in the application form, you may be assigned locally or remotely. You will only be presented opportunities outside of your local area if you specified that you were willing to be deployed to another location.
                </li>
              </ul>
            </li>
            <li>How long will assignments be for?
              <ul className={classes.indent}>
                <li>
                  Timing of assignments may vary. They may range from part time over a few days / weeks, to full time / indefinite. This is up to the facility.
                </li>
              </ul>
            </li>
            <li>Should I take leave from my current job?
              <ul className={classes.indent}>
                <li>
                  How much time you dedicate is up to you. You’re able to specify your availability in the application form and that’s what we use to match you with potential assignments.
                </li>
              </ul>
            </li>
            <li>Who will have access to the information I share?
              <ul className={classes.indent}>
                <li>
                  You information will only be accessible by vetted medical facilities, to determine if you would be a good fit.
                </li>
              </ul>
            </li>
          </ul>
        </Grid>
      </Grid>
    </Page>
  );
}



